import model from '../mixins/model';

export default {
    mixins: [model],
    model() {
        return {
            leads: []
        }
    },
    mounted() {
        this.fetch();
    },
    methods: {
        fetch() {

            return this.dispatch((resolve, reject) => {

                this.$http.request({ url: 'clients/:client/leads' })
                    .then((response) => {

                        this.model.leads = response.data.leads;
                    })
                    .then(resolve)
                    .catch(reject);

            });


        },
    }
}